var React = require('react');

function IconDriversLicense (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"8","width":"42","height":"31","fill":"white","key":0}),React.createElement("path",{"d":"M4 6H44C46.1 6 48 7.9 48 10V38C48 40.1 46.1 42 44 42H4C1.9 42 0 40.1 0 38V10C0 7.9 1.9 6 4 6ZM28 12V14H44V12H28ZM28 16V18H44V16H28ZM28 20V22H42V20H28ZM16 27.82C12 27.82 4 30 4 34V36H28V34C28 30 20 27.82 16 27.82ZM16 12C14.4087 12 12.8826 12.6321 11.7574 13.7574C10.6321 14.8826 10 16.4087 10 18C10 19.5913 10.6321 21.1174 11.7574 22.2426C12.8826 23.3679 14.4087 24 16 24C17.5913 24 19.1174 23.3679 20.2426 22.2426C21.3679 21.1174 22 19.5913 22 18C22 16.4087 21.3679 14.8826 20.2426 13.7574C19.1174 12.6321 17.5913 12 16 12Z","fill":"#2B2F35","key":1})]);
}

IconDriversLicense.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IconDriversLicense;

IconDriversLicense.default = IconDriversLicense;
